/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { ParserDependencies } from './dependenciesParserClass.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createParser } from '../../factoriesAny.js';
export var parserDependencies = {
  ParserDependencies: ParserDependencies,
  typedDependencies: typedDependencies,
  createParser: createParser
};